import { Badge, styled } from '@mui/material';

// profileAvatarSize(77px) 기준 비율
const PROFILE_AVATAR_SIZE = 77;
const ONLINE_DOT_SIZE = 10; // profileAvatarSize 기준
const OFFLINE_BADGE_SIZE = 16; // 고정 크기
const OFFLINE_BADGE_FONT_SIZE = 10; // 고정 크기
const OFFLINE_BADGE_PADDING = 4; // 고정 크기

const AvatarBadge = styled(Badge, {
    shouldForwardProp: (prop) => prop !== 'avatarSize',
})(({ theme, avatarSize = PROFILE_AVATAR_SIZE }) => {
    // avatarSize에 따른 비례 계산 (online dot만)
    const ratio = avatarSize / PROFILE_AVATAR_SIZE;
    const onlineDotSize = Math.round(ONLINE_DOT_SIZE * ratio);

    return {
        '& .MuiBadge-badge': {
            minWidth: OFFLINE_BADGE_SIZE,
            height: OFFLINE_BADGE_SIZE,
            padding: `0 ${OFFLINE_BADGE_PADDING}px`,
            borderRadius: 999,
            fontSize: OFFLINE_BADGE_FONT_SIZE,
            fontWeight: 700,
            lineHeight: `${OFFLINE_BADGE_SIZE}px`,
            boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
            transform: 'translate(70%, 25%)',
        },

        // 온라인(dot)
        '& .MuiBadge-badge.online': {
            backgroundColor: '#44b700',
            color: '#44b700',
            minWidth: onlineDotSize,
            width: onlineDotSize,
            height: onlineDotSize,
            padding: 0,
            borderRadius: '50%',
        },

        // 오프라인(상대시간 텍스트)
        '& .MuiBadge-badge.offline': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
        },

        // invisible 상태 처리 - 더 구체적인 선택자로 우선순위 확보
        '&.MuiBadge-invisible .MuiBadge-badge': {
            display: 'none !important',
            visibility: 'hidden !important',
            opacity: '0 !important',
            width: '0 !important',
            height: '0 !important',
            minWidth: '0 !important',
            padding: '0 !important',
            transform: 'scale(0) !important',
        },
        '&.MuiBadge-invisible .MuiBadge-badge.online': {
            display: 'none !important',
            visibility: 'hidden !important',
            opacity: '0 !important',
            width: '0 !important',
            height: '0 !important',
            minWidth: '0 !important',
            padding: '0 !important',
            transform: 'scale(0) !important',
        },
        '&.MuiBadge-invisible .MuiBadge-badge.offline': {
            display: 'none !important',
            visibility: 'hidden !important',
            opacity: '0 !important',
            width: '0 !important',
            height: '0 !important',
            minWidth: '0 !important',
            padding: '0 !important',
            transform: 'scale(0) !important',
        },
    };
});

export { AvatarBadge };
